export interface IMemberFeedback {
  id: string;
  feedback: string;
  selected?: boolean;
}

export class MemberFeedback {
  public id: string;
  public feedback: string;
  public selected?: boolean;

  constructor(data: IMemberFeedback) {
    this.id = data.id;
    this.feedback = data.feedback;
    this.selected = data.selected || false;
  }
}
